module.exports = __webpack_public_path__ + "img/1fie-d-calend.17848861.jpg";